export default "__VITE_ASSET__DdEGNo2B__"